<template>
  <div class="input-container" :class="{ 'input-container--focused': inputFocused }">
    <label
      v-if="!inputFocused && !data"
      class="v-label p-2"
      style="left: 12px; top: 10px; position: absolute; pointer-events: none; color: #00000099"
      :class="{ 'error--text': !!errorText }"
      >{{ label || 'dd/mm/yyyy' }}
    </label>
    <MaskedInput
      :disabled="disabled"
      v-bind="this.$attrs"
      v-model="data"
      mask="11/11/1111"
      class="input mr-1 pa-2"
      @focus.native="inputFocused = true"
      @blur.native="inputFocused = false"
      :class="{ 'input--error': !!errorText, 'input--clearable': clearable }"
    />
    <button
      v-if="clearable && data && !disabled"
      type="button"
      class="clear-button"
      tabindex="-1"
      @mousedown.prevent
      @click="clear"
    >
      <v-icon>mdi-close</v-icon>
    </button>
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import { formatHoChiMinhDate, parseHoChiMinhDate } from '@/helpers/dateTime'
import MaskedInput from 'vue-masked-input'
import VInput from 'vuetify/lib/components/VInput/VInput.js'

export default {
  extends: VInput,
  props: {
    date: String,
    // rules: {
    //   type: Array,
    //   default: () => []
    // },
    // hideDetails: {
    //   type: Boolean,
    //   default: false
    // },
    label: String,
    disabled: Boolean,
    clearable: Boolean,
  },
  components: {
    MaskedInput,
  },

  data: () => ({
    data: '',
    menu: false,
    errorText: '',
    inputFocused: false,
  }),

  methods: {
    validate(force) {
      // overide validate VInput
      if (force) {
        this.updated(this.data)
      }

      return !this.errorText
    },
    updated(value) {
      if (this.rules && this.rules.length) {
        let errorText = ''
        for (const rule of this.rules) {
          errorText = rule(value)
          if (errorText !== true) break
        }
        if (errorText !== true) this.errorText = errorText
        else this.errorText = null
      }

      if (value) {
        const isoDate = !this.errorText ? parseHoChiMinhDate(this.data).toISOString() : ''
        this.$emit('update:date', isoDate)
        this.$emit('input', isoDate)
      } else {
        this.$emit('update:date', '')
        this.$emit('input', '')
      }
      this.menu = false
    },
    reset() {
      if (this.date) {
        this.data = formatHoChiMinhDate(this.date)
      } else {
        this.data = ''
      }
    },
    clear() {
      this.data = ''
      this.errorText = ''
      this.$emit('update:date', '')
      this.$emit('input', '')
    },
    onEnterPress() {
      this.$emit('onEnterPress')
    },
  },
  created() {
    this.reset()
  },
  watch: {
    data() {
      this.updated(this.data)
    },
    date(newValue) {
      if (newValue) {
        this.data = formatHoChiMinhDate(newValue)
      } else {
        this.data = ''
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.input-container {
  position: relative;
}
.input {
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 4px;
  outline: none;
  padding: 7px 8px;
  box-sizing: border-box;
}

.input:focus {
  border: 2px solid #0d47a1;
  padding: 6px 7px;
}

.input--clearable {
  padding-right: 32px !important;
}

.input--clearable:focus {
  padding-right: 31px !important;
}

.clear-button {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #757575;
  cursor: pointer;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.input-container:hover .clear-button,
.input-container--focused .clear-button {
  opacity: 1;
  pointer-events: auto;
}

.input-container--focused .clear-button {
  color: #0d47a1;
}

.clear-button .v-icon {
  color: currentColor;
}

.input--error {
  border: 2px solid #b71c1c !important;
  padding: 6px 7px;
}
.error-text {
  margin-top: 2px;
  min-height: 14px;
  // line-height: 14px;
  margin-bottom: -4px;
}
</style>
